import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CoreModule } from '../core/core.module';
import { NotificationPrefsRoutingModule } from './notification-prefs-routing.module';
import * as fromNotificationPrefs from './store';
import { PreferencesComponent } from './pages';
import {
  ContactInfoFormComponent,
  EditProfileComponent,
  RegisterPhoneComponent,
  RegisterEmailComponent,
  RegisterWhatsAppComponent,
  VerifyCodeEmailComponent,
  VerifyCodePhoneComponent,
  OptInSmsPhoneComponent,
  PreferenceSettingsComponent
} from './components';
import { AppDisclaimerComponent, NotificationBannerComponent, PhoneInputComponent, ThemeSwitcherComponent } from '@app/shared/components';

@NgModule({
  declarations: [
    PreferencesComponent,
    EditProfileComponent,
    RegisterPhoneComponent,
    RegisterEmailComponent,
    RegisterWhatsAppComponent,
    VerifyCodeEmailComponent,
    VerifyCodePhoneComponent,
    OptInSmsPhoneComponent,
    ContactInfoFormComponent,
    PreferenceSettingsComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNotificationPrefs.notificationPrefsModuleKey, fromNotificationPrefs.reducers),
    EffectsModule.forFeature([fromNotificationPrefs.NotificationPrefsEffects]),
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationPrefsRoutingModule,
    CoreModule,
    ImageCropperModule,
    TranslateModule.forChild({
      extend: true
    }),
    AppDisclaimerComponent,
    ThemeSwitcherComponent,
    NotificationBannerComponent,
    PhoneInputComponent
  ],
  exports: []
})
export class NotificationPrefsModule {}
